import { NETWORK_ACTION, NETWORK_PATH, NETWORK_REQUEST_PATH } from '../../constants'
import getRequestsNetworkSelect from '../../selectors/get-requests'
import setReduxAction from '../../../redux/actions/set'

function incrementRetryCountNetworkAction (action) {
  return (dispatch, getState) => {
    const requests = getRequestsNetworkSelect(getState())
    const request = requests.find(request => request.action === action)
    dispatch(setReduxAction({
      type: NETWORK_ACTION.INCREMENT_RETRY_COUNT,
      payload: {
        path: NETWORK_PATH.REQUESTS,
        value: requests.map(req => {
          if (req === request) {
            req = {
              ...req,
              [NETWORK_REQUEST_PATH.RETRY_COUNT]: (
                (
                  req[NETWORK_REQUEST_PATH.RETRY_COUNT] || 0
                ) + 1
              )
            }
          }
          return req
        })
      }
    }))
  }
}

export default incrementRetryCountNetworkAction
